import { datadogRum } from "@datadog/browser-rum";
import pageData from "common/page-data";

const FUNNEL_STEP_KEYS = [
  "contacts",
  "areas",
  "edit",
  "landing_page",
  "choose_plan",
  "select_audience",
  "launch",
  "custom_launch",
  "geo_target",
  "tv_preview",
  "campaign_venues",
  "preview_launch"
];

const rumPageEligibility = () => {
  const pathname = window.location.pathname || "";
  const isMyAccountsAppPage = Boolean(document.getElementById("account-app"));
  const isEnterpriseDashboardPage = Boolean(document.querySelector(".partner-dashboard"));
  const isFunnelPage = new RegExp(`/\\d+/(${FUNNEL_STEP_KEYS.join("|")})(/|$)`).test(pathname);

  return {
    pathname,
    isMyAccountsAppPage,
    isEnterpriseDashboardPage,
    isFunnelPage,
    isRumAllowed: isMyAccountsAppPage || isEnterpriseDashboardPage || isFunnelPage
  };
};

const rumEligibility = rumPageEligibility();

if (process.env.RAILS_ENV === "production") {
  if (pageData.get("pageStatusCode") === 200 && rumEligibility.isRumAllowed) {
    const botPattern =
      "(googlebot/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
    const regex = new RegExp(botPattern, "i");
    const conditionalSampleRate = regex.test(navigator.userAgent) ? 0 : 40;

    datadogRum.init({
      applicationId: process.env.DATADOG_APPLICATION_ID,
      clientToken: process.env.DATADOG_CLIENT_TOKEN,
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: "datadoghq.com",
      service: "promote",
      env: process.env.RELEASE_STAGE || process.env.RAILS_ENV,
      sessionSampleRate: conditionalSampleRate,
      sessionReplaySampleRate: 5,
      defaultPrivacyLevel: "mask-user-input"
    });
  }
}
